import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const WEEK_DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

export function WeekScheduleEditor({ value, onChange, testidPrefix = "schedule" }) {
  const days = value || {};
  const setDay = (d, ranges) => onChange({ ...days, [String(d)]: ranges });

  return (
    <div className="space-y-3">
      {WEEK_DAYS.map((label, d) => {
        const ranges = days[String(d)] || [];
        return (
          <div key={d} className="rounded-lg border border-slate-200 p-3" data-testid={`${testidPrefix}-day-${d}`}>
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-slate-900">{label}</span>
              {ranges.length === 0 ? (
                <div className="flex items-center gap-2">
                  <span className="text-xs text-slate-400">Fermé</span>
                  <Button type="button" variant="outline" size="sm" onClick={() => setDay(d, [{ start: "09:00", end: "12:00" }])} data-testid={`${testidPrefix}-open-${d}`}>
                    <Plus className="mr-1 h-3 w-3" /> Ouvrir
                  </Button>
                </div>
              ) : (
                <Button type="button" variant="ghost" size="sm" onClick={() => setDay(d, [])} data-testid={`${testidPrefix}-close-${d}`} className="text-slate-400">
                  Fermer ce jour
                </Button>
              )}
            </div>
            {ranges.map((r, i) => (
              <div key={i} className="mt-2 flex items-center gap-2">
                <input
                  type="time"
                  value={r.start}
                  onChange={(e) => setDay(d, ranges.map((x, j) => (j === i ? { ...x, start: e.target.value } : x)))}
                  className="h-10 rounded-md border border-slate-300 px-2 text-sm"
                  data-testid={`${testidPrefix}-start-${d}-${i}`}
                />
                <span className="text-slate-400">→</span>
                <input
                  type="time"
                  value={r.end}
                  onChange={(e) => setDay(d, ranges.map((x, j) => (j === i ? { ...x, end: e.target.value } : x)))}
                  className="h-10 rounded-md border border-slate-300 px-2 text-sm"
                  data-testid={`${testidPrefix}-end-${d}-${i}`}
                />
                <button type="button" onClick={() => setDay(d, ranges.filter((_, j) => j !== i))} className="rounded p-1 text-slate-400 hover:text-red-600" data-testid={`${testidPrefix}-remove-${d}-${i}`}>
                  <X className="h-4 w-4" />
                </button>
              </div>
            ))}
            {ranges.length > 0 && (
              <Button type="button" variant="ghost" size="sm" className="mt-2 text-blue-600" onClick={() => setDay(d, [...ranges, { start: "14:00", end: "18:00" }])} data-testid={`${testidPrefix}-addrange-${d}`}>
                <Plus className="mr-1 h-3 w-3" /> Ajouter une plage (pause déjeuner)
              </Button>
            )}
          </div>
        );
      })}
    </div>
  );
}
